/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Ryan Duffy
 */

import { Injectable } from '@angular/core';
import { HistoryModel } from '@app/models/history.model';
import { ApiBaseService } from '@app/services/api-services/api-base.service';
import { HttpClient } from '@angular/common/http';
import { AuthUserService } from '@app/services/authentication/auth-user-service';
@Injectable({
  providedIn: 'root',
})
export class HistoryListService extends ApiBaseService {
  private _historyList: HistoryModel[] = [];
  protected _endpoint = 'history';

  constructor(http: HttpClient, authUserService: AuthUserService) {
    super(http, authUserService);
  }

  get historyList(): HistoryModel[] {
    return this._historyList;
  }

  set historyList(value: HistoryModel[]) {
    this._historyList = value;
  }

  /**
   *  Ryan Duffy
   *
   *  getHistoryByEventId
   *
   * : Get an history based on the id by checking the list
   *
   * @param id of type string
   *
   * @returns Void: gets the history item with the id that meets the query
   */
  getHistoryByEventId(eventId: string): HistoryModel[] {
    const list = [];
    for (const history of this.historyList) {
      if (history.eventId === eventId) {
        list.push(history);
      }
    }
    return list;
  }

  /**
   *  Ryan Duffy
   *
   *  getHistoryByEventId
   *
   * : Get an history based on the id by checking the list
   *
   * @param id of type string
   *
   * @returns Void: gets the history item with the id that meets the query
   */
  getSingleHistoryByEventId(eventId: string): HistoryModel {
    let historyItem: HistoryModel;
    for (const history of this.historyList) {
      if (history.eventId === eventId) {
        historyItem = history;
        return historyItem;
      }
    }
    return null;
  }

  /**
   *   Ryan Duffy
   *
   *  addtoList
   *
   * : handles the insert of a new histor into the list
   *
   * @param data of type HistoryModel
   *
   * @returns Void: inserts a new history item into the lsit
   */
  addToList(data: HistoryModel): void {
    this.historyList.push(data);
  }
  /**
   *   Warren Dowey & Ryan Duffy
   *
   *  removeFromList
   *
   * : deletes an history from the list
   *
   * @param data of type HistoryModel
   *
   * @returns Void: deletes a history item
   */
  removeFromList(data: HistoryModel): void {
    let index = 0;
    for (const history of this.historyList) {
      if (history.eventId === data.eventId) {
        this.historyList.slice(index, 1);
      }
      index++;
    }
  }
  /**
   *  Warren Dowey
   *
   *  updateInList
   *
   * : handles the update of an history in the list
   *
   * @param data of type HistoryModel
   *
   * @returns Void: update the list with the data
   */
  updateInList(data: HistoryModel): void {
    for (let history of this.historyList) {
      if (history.eventId === data.eventId) {
        history = data;
      }
    }
  }
  /**
   *  Warren Dowey
   *
   *  handleData
   *
   * : handles the data from the list by extending the handleData function from the API base service
   *
   * @param data of type HistoryModel
   *
   * @returns Void: get the history from the postgres database and create the list
   */
  protected handleData(data: any): void {
    this.historyList = [];
    let history: HistoryModel;
    super.handleData(data);
    for (const item of data) {
      history = new HistoryModel();
      this.addToList(history.fromJson(item));
    }
  }
}
